import {lazy} from "react";

export const TasksSingleVoyagesLazy = lazy(() => import('./TasksSingleVoyages'))
